import axios from 'axios'
import Request from 'src/utils/request'

/**
 * 获取测试签名
 * @returns
 */
export const getOssSignatureApi = () => {
  return Request({
    url: '/system/oss/signature',
    unique: true,
  })
}

// 获取文件后缀名
function getFileSuffix (name) {
  const i = name.lastIndexOf('.')
  if (i < 0) return ''
  return name.slice(i + 1).toLowerCase()
}

/** 常见图片扩展名（浏览器未给出 MIME 时的兜底） */
const IMAGE_EXT_FALLBACK = new Set([
  'png', 'jpg', 'jpeg', 'jpe', 'jfif', 'pjpeg', 'pjp', 'gif', 'webp', 'bmp', 'dib', 'svg', 'svgz',
  'ico', 'cur', 'avif', 'heic', 'heif', 'hif', 'tif', 'tiff', 'tff', 'jp2', 'j2k', 'jpf', 'jpx',
  'jpm', 'mj2', 'apng', 'xbm', 'xpm', 'ppm', 'pgm', 'pbm', 'pnm', 'pcx', 'psd', 'tga', 'tpic',
  'dds', 'exr', 'hdr', 'pic', 'rgb', 'rgba', 'sgi', 'bw', 'ras', 'im1', 'im8', 'im24', 'im32',
])

/**
 * 是否为可上传的图片文件（优先 MIME image/*，否则按扩展名兜底）
 * @param {File} file
 */
export function isImageFile (file) {
  if (!file || !file.name) return false
  const t = (file.type || '').toLowerCase()
  if (t.startsWith('image/')) return true
  const ext = getFileSuffix(file.name)
  return ext ? IMAGE_EXT_FALLBACK.has(ext) : false
}
// 随机字母，文件名
function getRandomString (len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let str = ''
  for (let i = 0; i < len; i++) {
    str += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return str
}

// 获取阿里签名
async function getSignature () {
  const signature = await getOssSignatureApi()
  return signature
}

// 文件上传
export async function uploadFile (file) {
  const signature = await getSignature()
  const formData = new FormData()
  const name = getRandomString() + '.' + getFileSuffix(file.name) + ''
  formData.append('key', signature.dir + name)
  formData.append('policy', signature.policy)
  formData.append('OSSAccessKeyId', signature.accessid)
  formData.append('success_action_status', '200')
  formData.append('callback', signature.callback)
  formData.append('signature', signature.signature)
  formData.append('file', file)
  const { data, status } = await axios.post(signature.host, formData, {
    'Content-Type': 'multipart/form-data',
  })
  if (status === 200 && data.status === 'success') {
    return data.data
  } else {
    return Promise.reject(data.message)
  }
}
